export const buildBulkProductSelectionState = (state, isChecked) => state.map((item) => ({ ...item, isChecked }));
